import { Col, Row } from "react-bootstrap"

const BankAccountView = ({accNum="0000", status="Active", balance=100}) => {
    // Balance masking is now handled by the backend
    // If balance is 0, show "---" for better UX
    const displayBalance = balance === 0 ? "---" : balance

    return <Row>
        <Col>{accNum}</Col>
        <Col>{status}</Col>
        <Col sm={3} lg={3} style={{textAlign:"end"}}>
            {displayBalance}
        </Col>
    </Row>
}

export default BankAccountView